import { StackmatState } from './ICubingService';

export type TimerUpdateFn = (state: StackmatState) => void;

/**
 * Creates a ticking loop that updates timeMilli based on host clock alignment with cube start.
 */
export function createStartAnimationLoop(
  getIsRunning: () => boolean,
  getState: () => StackmatState,
  updateState: (newState: StackmatState) => void,
  animationStartOffset: number
): () => void {
  let rafId: number;

  const loop = () => {
    if (!getIsRunning()) return;

    const elapsed = performance.now() - animationStartOffset;

    const updatedState = {
      ...getState(),
      timeMilli: elapsed,
    };

    updateState(updatedState);

    rafId = requestAnimationFrame(loop);
  };

  rafId = requestAnimationFrame(loop);

  return () => cancelAnimationFrame(rafId);
}